module.exports = __webpack_public_path__ + "img/erweima2.d145ae68.png";